import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Templates {
  templateNoteVisibility: string;
}

const initialState: Templates = {
  templateNoteVisibility: "Public",
};

const templateSlice = createSlice({
  name: "templateVisibility",
  initialState,
  reducers: {
    setTemplateVisibility: (state, action: PayloadAction<string>) => {
      state.templateNoteVisibility = action?.payload;
    },
  },
});

export const { setTemplateVisibility } = templateSlice.actions;
export default templateSlice.reducer;
